export default __webpack_public_path__ + "static/media/Img_FindYourJoy_04.c4cba83e.png";